(function() {
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('referral_code')) return;

    let geoRaw;
    try {
      geoRaw = sessionStorage.getItem('ABTastyGeoloc');
    } catch (e) {
      return;
    }
    if (!geoRaw) return;

    let geo;
    try {
      geo = JSON.parse(geoRaw);
    } catch (e) {
      return;
    }

    const country = (geo && geo.country_iso_code ? String(geo.country_iso_code) : '').toUpperCase();
    const markets = {french: ['FR', 'BE', 'LU'], eu: ['DK', 'IT', 'ES', 'PT', 'PL', 'SE', 'NL']};

    const market = markets.french.indexOf(country) !== -1 ? 'french'
      : markets.eu.indexOf(country) !== -1 ? 'eu'
        : null;
    if (!market) return;

    const path = url.pathname || '/';
    const firstSegment = path.split('/').filter(Boolean)[0] || '';
    const localizedPrefixes = ['fr', 'en', 'fr-fr', 'de-fr', 'en-eu', 'de-eu', 'fr-eu'];
    if (localizedPrefixes.indexOf(firstSegment) !== -1) return;

    const langPrefs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language])
      .filter(Boolean)
      .map(function (lang) {
        return lang.toLowerCase();
      });

    const matchesLang = function (prefix) {
      for (let i = 0; i < langPrefs.length; i += 1) {
        const lang = langPrefs[i];
        if (lang === prefix || lang.split('-')[0] === prefix) return true;
      }
      return false;
    };

    const pickPrefix = function () {
      if (market === 'french') {
        if (matchesLang('fr')) return 'fr-fr';
        if (matchesLang('de')) return 'de-fr';
        return 'fr-fr';
      }
      if (market === 'eu') {
        if (matchesLang('fr')) return 'fr-eu';
        if (matchesLang('de')) return 'de-eu';
        if (matchesLang('en')) return 'en-eu';
        return 'en-eu';
      }
      return '';
    };

    const targetPrefix = pickPrefix();
    if (!targetPrefix) return;

    const restOfPath = path.replace(/^\/+/, '');
    url.pathname = '/' + targetPrefix + (restOfPath ? '/' + restOfPath : '');
    url.searchParams.set('country', country);
    const targetUrl = url.toString();

    if (targetUrl !== window.location.href) {
      window.location.replace(targetUrl);
    }
  } catch (e) {
  }
})();

(function () {
  const localizedPrefixes = ['fr', 'en', 'fr-fr', 'de-fr', 'en-eu', 'de-eu', 'fr-eu'];
  const getBasePath = function () {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (root) return root;
    const path = window.location.pathname || '/';
    const firstSegment = path.split('/').filter(Boolean)[0] || '';
    if (localizedPrefixes.indexOf(firstSegment) !== -1) {
      return '/' + firstSegment + '/';
    }
    return '/';
  };

  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('a');
    if (!link) return;
    const wrapper = link.closest('[class*="_ReferralScreenClose"]');
    if (!wrapper) return;
    const params = new URLSearchParams(window.location.search);
    params.delete('referral_code');
    params.delete('country');
    const query = params.toString();
    const destination = getBasePath() + (query ? '?' + query : '');
    if (link.getAttribute('href') === destination) return;
    event.preventDefault();
    window.location.assign(destination);
  }, true);
})();
